import { render } from "./EditPress.vue?vue&type=template&id=03ae56ad"
import script from "./EditPress.vue?vue&type=script&lang=js"
export * from "./EditPress.vue?vue&type=script&lang=js"
script.render = render

export default script